import { gql, useMutation } from '@apollo/client';

import { OdProtosListingsData_ExperiencePartnerSupportRequestType as SUPPORT_REQUEST_TYPE } from '../../../__generated__/athenaGlobalTypes';
import {
  RequestExperiencePartnerSupport,
  RequestExperiencePartnerSupportVariables,
} from './__generated__/RequestExperiencePartnerSupport';

export const REQUEST_EXPERIENCE_PARTNER_SUPPORT = gql`
  mutation RequestExperiencePartnerSupport(
    $lwcProductId: String!
    $type: OdProtosListingsData_ExperiencePartnerSupportRequestType!
  ) {
    odProtosListingsServicesListwithcertaintyproduct {
      requestExperiencePartnerSupport(input: { lwcProductId: $lwcProductId, type: $type }) {
        _empty
      }
    }
  }
`;

/**
 * Used for requesting support from an experience partner
 */
export const useRequestExperiencePartnerSupport = () => {
  const [requestExperiencePartnerSupportMutation, { data, error, loading }] = useMutation<
    RequestExperiencePartnerSupport,
    RequestExperiencePartnerSupportVariables
  >(REQUEST_EXPERIENCE_PARTNER_SUPPORT, {
    fetchPolicy: 'no-cache',
    context: {
      clientName: 'athena',
    },
  });

  const requestExperiencePartnerSupport = (lwcProductId: string, type: SUPPORT_REQUEST_TYPE) =>
    requestExperiencePartnerSupportMutation({
      variables: { lwcProductId, type },
    });
  return { requestExperiencePartnerSupport, data, loading, error };
};
